import { AssignStudyTemplatePlugin } from './AssignStudyTemplatePlugin';
import { DigitalSignaturePlugin } from './DigitalSignaturePlugin';
import { FormDateFieldPlugin } from './FormDateFieldPlugin';
import { FormFilePlugin } from './FormFilePlugin';
import { FormHtmlPlugin } from './FormHtmlPlugin';
import { FormMultiSelectPlugin } from './FormMultiSelectPlugin';
import { FormNumberFieldPlugin } from './FormNumberFieldPlugin';
import { FormRadioGroupPlugin } from './FormRadioGroupPlugin';
import { FormSelectFieldPlugin } from './FormSelectFieldPlugin';
import { FormSliderPlugin } from './FormSliderPlugin';
import { FormTextFieldPlugin } from './FormTextFieldPlugin';
import { FormTimeFieldPlugin } from './FormTimeFieldPlugin';
import { FormWearablePlugin } from './FormWearablePlugin';
import { FormYesNoPlugin } from './FormYesNoPlugin';
import { NotebookFieldPlugin } from './NotebookFieldPlugin';
import { QuitStudyParticipantPlugin } from './QuitStudyParticipantPlugin';
import { RedirectPlugin } from './RedirectPlugin';
import { FormNumberPickerPlugin } from './FormNumberPickerPlugin';
import { QualificationPlugin } from './QualificationPlugin';
import { FormBirthDatePlugin } from './FormBirthDatePlugin';
import { FormStatePlugin } from './FormStatePlugin';
import { FormBiologicalSexPlugin } from './FormBiologicalSexPlugin';
import { FormPhoneNumberPlugin } from './FormPhoneNumberPlugin';

export const getDefaultFormElementPlugins = () => [
  FormTextFieldPlugin,
  FormNumberFieldPlugin,
  FormMultiSelectPlugin,
  FormRadioGroupPlugin,
  FormYesNoPlugin,
  FormDateFieldPlugin,
  FormTimeFieldPlugin,
  FormSelectFieldPlugin,
  FormSliderPlugin,
  FormHtmlPlugin,
  FormFilePlugin,
  FormWearablePlugin,
  AssignStudyTemplatePlugin,
  RedirectPlugin,
  DigitalSignaturePlugin,
  QuitStudyParticipantPlugin,
  NotebookFieldPlugin,
  FormNumberPickerPlugin,
  QualificationPlugin,
  FormBirthDatePlugin,
  FormStatePlugin,
  FormBiologicalSexPlugin,
  FormPhoneNumberPlugin
];
